import Backbone from 'backbone';
import _ from 'underscore';
import ComponentBase from 'components/_base/ComponentBase';
import jQuery from 'jquery';

const JPTransitStepsInfo = ComponentBase.extend(
    {
        template: require('./jpTransitStepsInfo.hbs'),

        componentClass: 'jp-transit-steps',

        identifier: 'jp-transit-steps',

        events: {
            'click .jp-transit-step-walking-steps-clickable': '_clickArrowWalk'
        },

        constructor(options) {
            options.identifier = this.identifier;
            ComponentBase.prototype.constructor.call(this, options);
            this.widget = options.widget;
            this.componentConstructorClass = options.componentConstructorClass;
            this.travelMode = options.properties.travelMode;
            this.route = options.properties.route;
            this.summary = options.properties.summary;
        },

        initialize(options = {}) {
            let componentClass = 'jp-transit-steps-info';
            this.templateConfig = _.extend(options, {
                componentClass: componentClass,
                originText: options.properties.originText,
                destinationText: options.properties.destinationText,
                route: options.properties.route,
                summary: options.properties.summary
            });
            Backbone.View.prototype.initialize.call(this, options);
            this.render();
        },

        _clickArrowWalk(e) {
            let arrowComponent = jQuery(e.target);
            let stepsContainer = arrowComponent.parent().parent().find('.jp-transit-step-walking-steps-container');
            if (e.target.className.indexOf('lmm-icon-ic_keyboard_arrow_down_black_24px') > -1) {
                arrowComponent.removeClass('lmm-icon-ic_keyboard_arrow_down_black_24px');
                arrowComponent.addClass('lmm-icon-ic_keyboard_arrow_up_black_24px');
                stepsContainer.slideDown(500);
            } else {
                arrowComponent.removeClass('lmm-icon-ic_keyboard_arrow_up_black_24px');
                arrowComponent.addClass('lmm-icon-ic_keyboard_arrow_down_black_24px');
                stepsContainer.slideUp(500);
            }
        }
    }
);
export default JPTransitStepsInfo;


// WEBPACK FOOTER //
// ./src/components/JPTransitStepsInfo/JPTransitStepsInfo.js